import { render } from "./ButtonTopbar.vue?vue&type=template&id=bfba2954&scoped=true"
import script from "./ButtonTopbar.vue?vue&type=script&lang=js"
export * from "./ButtonTopbar.vue?vue&type=script&lang=js"

import "./ButtonTopbar.vue?vue&type=style&index=0&id=bfba2954&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bfba2954"]])

export default __exports__